// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '../../../../../../../node_module_clones/recompose';

// Selectors
import { boardEditorAddSectionSelector } from './boardEditorSuggestionsSelector';

// Actions
import { addUserAsEditor, submitAddEditorInputText } from './boardEditorPanelActions';
import { navigateToEmailVerification } from '../../../../../../reducers/navigationActions';

// Components
import fetchGoogleContactsOnMountDecorator from '../../../../../../user/google/components/fetchGoogleContactsOnMountDecorator';
import UserSelectionInput from '../../../../../../components/form/fields/userSelectionInput/UserSelectionInput';
import LoadableEmailVerificationRequiredModal from '../../../../../../user/account/emailVerification/LoadableEmailVerificationRequiredModal';

// Styles
import './BoardEditorAddSection.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchAddUserAsEditor: ({ user }) => dispatch(addUserAsEditor({ user })),
    dispatchAddEditorInputText: ({ inputText }) => dispatch(submitAddEditorInputText({ inputText })),
    dispatchOpenEmailVerificationModal: () => dispatch(navigateToEmailVerification()),
});

const enhance = compose(
    fetchGoogleContactsOnMountDecorator,
    connect(boardEditorAddSectionSelector, mapDispatchToProps),
);

const BoardEditorAddSection = (props) => {
    const {
        dispatchAddUserAsEditor,
        dispatchAddEditorInputText,
        dispatchOpenEmailVerificationModal,
        filterUserIds,
        isCurrentUserEmailVerified,
        isPhoneOrMobileAppMode,
    } = props;

    const inputRef = React.useRef();

    React.useEffect(() => {
        !isCurrentUserEmailVerified && LoadableEmailVerificationRequiredModal.preload();
    }, []);

    const onFocusUnverifiedUser = () => {
        dispatchOpenEmailVerificationModal();
        inputRef.current && inputRef.current.blur();
    };

    return (
        <div className="BoardEditorAddSection">
            <UserSelectionInput
                submitLabel="Send invite"
                inputRef={inputRef}
                onFocus={!isCurrentUserEmailVerified ? onFocusUnverifiedUser : null}
                filterUserIds={filterUserIds}
                handleSubmitSelectUser={dispatchAddUserAsEditor}
                handleSubmitSelectUserViaText={dispatchAddEditorInputText}
                isPhoneOrMobileAppMode={isPhoneOrMobileAppMode}
            />
        </div>
    );
};

BoardEditorAddSection.propTypes = {
    dispatchAddUserAsEditor: PropTypes.func,
    dispatchOpenEmailVerificationModal: PropTypes.func,
    dispatchAddEditorInputText: PropTypes.func,
    filterUserIds: PropTypes.array,
    isCurrentUserEmailVerified: PropTypes.bool,
    currentUserEmail: PropTypes.string,
    isPhoneOrMobileAppMode: PropTypes.bool,
};

export default enhance(BoardEditorAddSection);
